'use strict';

var abrirChamadoMdl = angular.module('abrirChamadoMdl', []);
abrirChamadoMdl.config(abrirChamadoConfig);
abrirChamadoConfig.$inject = ['$stateProvider'];

function abrirChamadoConfig($stateProvider) {

    $stateProvider

    .state('app.abrir-chamado-segmentos', {
        url: '/abrir-chamado-segmentos/:grupoDeSuporteId/:grupoDeSuporteSegmentoId',
        controller: 'abrirChamadoSegmentosCtrl',
        controllerAs: '$ctrl',
        template: require('./abrir-chamado-segmentos-template.html'),
        data: {
            autorizacao: true,
            redirecionarPara: 'autenticacao.login'
        }
    })
    .state('app.abrir-chamado', {
        url: '/abrir-chamado/grupos-suporte/:grupoDeSuporteId/grupos-suporte-segmentos/:grupoDeSuporteSegmentoId',
        controller: 'abrirChamadoCtrl',
        controllerAs: '$ctrl',
        template: require('./abrir-chamado-template.html'),
        data: {
            autorizacao: true,
            redirecionarPara: 'autenticacao.login'
        }
    });
}



// WEBPACK FOOTER //
// ./src/modules/abrir-chamado/abrir-chamado-config.js